import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/acceso/comercio/registro")({
  beforeLoad: () => {
    throw redirect({ href: "/contratar?start=1", replace: true });
  },
});
